import Address from './Address';

export { type AddressProps } from './Address';
export default Address;
